import React, { useEffect, useRef, useState } from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { themeCollections } from '../data/mockData';
import { Button } from './ui/button';

const ThemeCollections = ({ onThemeClick }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const node = sectionRef.current;
    if (node) {
      observer.observe(node);
    }

    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, []);

  return (
    <section className="theme-collections-section" id="collections" ref={sectionRef}>
      <div className="collections-container">
        <div className={`collections-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="collections-title">
            Pick Your <span className="title-emphasis">Aesthetic ✨</span>
          </h2>
          <p className="collections-subtitle">
            Choose from our curated vibes or go custom – we're literally here to make your vision come to life
          </p>
        </div>

        <div className="collections-grid">
          {themeCollections.map((theme, index) => (
            <div
              key={theme.id}
              className={`collection-card ${isVisible ? 'visible' : ''} ${hoveredCard === theme.id ? 'hovered' : ''} ${theme.isCustom ? 'custom-card' : ''}`}
              style={{ transitionDelay: `${index * 100}ms` }}
              onMouseEnter={() => setHoveredCard(theme.id)}
              onMouseLeave={() => setHoveredCard(null)}
              onClick={() => onThemeClick(theme)}
            >
              {theme.isCustom && (
                <div className="custom-badge">
                  <Sparkles className="w-4 h-4" />
                  <span>Design Your Own</span>
                </div>
              )}
              
              <div className="collection-image-wrapper">
                <img 
                  src={`${theme.image}?w=800&q=80`} 
                  alt={theme.name}
                  className="collection-image"
                />
                <div className="collection-overlay"></div>
              </div>
              
              <div className="collection-content">
                <div className="collection-tagline">{theme.tagline}</div>
                <h3 className="collection-name">{theme.name}</h3>
                <p className="collection-description">{theme.description}</p>
                
                <Button 
                  className="collection-button"
                  variant="ghost"
                >
                  {theme.isCustom ? "Start Customizing" : "Explore Collection"}
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ThemeCollections;
